export default __webpack_public_path__ + "static/media/footerCats1px.e2dfa252.webp";